<nz-row nzJustify="end">
  <nz-col *ngIf="!($sortable | async)" nzFlex>
    <button nz-button nzType="primary" (click)="reorder()">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Reihenfolge übernehmen
    </button>
  </nz-col>
</nz-row>
<nz-row>
  <nz-col nzSpan="24">
    <nz-list *ngIf="fotoKategorien.result$ | async" nzSize="large" [nzLoading]="$loading | async" cdkDropList (cdkDropListDropped)="reorder($event)">
      <nz-list-item *ngFor="let fotoKategorie of (fotoKategorien.result$ | async).fotoKategorien" (click)="select.emit(fotoKategorie)" cdkDrag class="drag-container">
        <nz-list-item-meta [nzDescription]="ListDescription">
          <ng-template #ListDescription>
            <!--- << description    -->
            <!---    description >> -->
          </ng-template>
          <nz-list-item-meta-title>
            <a>
              <!--- << content    -->
              <pbc-color-icon [icon]="fotoKategorie.icon" [color]="fotoKategorie.color"></pbc-color-icon>
              {{ fotoKategorie.name }}
              <!---    content >> -->
            </a>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <ul nz-list-item-actions>
          <nz-list-item-action>
            <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
            <a style="margin-left: 16px" *ngIf="$sortable | async" cdkDragHandle><i nz-icon nzType="menu" nzTheme="outline"></i></a>
          </nz-list-item-action>
        </ul>
      </nz-list-item>
    </nz-list>
  </nz-col>
</nz-row>
